window.addEventListener("DOMContentLoaded",
    function(e) {
        $(".umbraco-forms-merlin form").on('submit',
            function(e) {
                var formName = $(this).parent().data('form-name');
                if (formName !== 'undefined') {
                    window.dataLayer.push({ "event": 'forms-'+formName });
                }
            });
    });

window.addEventListener('pageshow', function() {
    document.querySelectorAll('.umbraco-forms-merlin form').forEach(function(form) {
        form.reset();
    });
});